import React, { useRef,useEffect,useState,useMemo,Suspense,useCallback } from 'react'
import { Canvas, useFrame, useThree,useLoader,extend } from '@react-three/fiber'
import * as THREE from 'three'
import { Plane,TextureLoader} from 'three';
import { Stats,useIntersect,Line, Image, Sky, ScrollControls, Scroll ,Loader,useScroll,
    useGLTF,OrbitControls ,PerspectiveCamera,useProgress,Html,Decal,Lightformer,
    Caustics,MeshTransmissionMaterial,Environment,RandomizedLight,AccumulativeShadows,RenderTexture,Text,Edges,CameraControls,useTexture,Outlines} from '@react-three/drei'
 
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader';
import { BrowserView, MobileView, isBrowser, isMobile ,isAndroid} from 'react-device-detect';
import { easing } from 'maath'
import {gsap,TweenMax} from "gsap";
import './style.css';
import AppConfig from './Config.js';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';
import { math } from '@tensorflow/tfjs';
import { a } from "@react-spring/three"
import { useStore } from './store'
import Uilayer from './Uilayer';
import ReactHowler from 'react-howler';
import { Howl, Howler } from 'howler';


let Android=false
let testmode=true
const hostloca=AppConfig.cdnUrl;
 // 生成随机颜色的函数
 const generateRandomColor = () => '#' + Math.floor(Math.random() * 16777215).toString(16);
// 创建包含10个随机颜色的数组
//const cuberandom = Array.from({ length: 64 }, generateRandomColor);
//初始化数组
let countdow=2
let cubecount=64
let firstin=true
let introanimate=false
const cuberandom = create2DArray(8, 8, 0);
let cubearray= create2DArray(8, 8, 0);
let cubeposearray= create2DArray(8, 8, 0);
let cubeObjarray=create2DArray(8, 8, 0);
let tempcubeObjmark=create2DArray(8, 8, 0);
let tempcubearray=create2DArray(8, 8, 0);
let tempmatcharray=create2DArray(8, 8, 1);

let tempPareSourcearray=create2DArray(8, 8, 0);


let deletemark=[]
let blankmark=[]
let deleteProcess=false  //runing delete proceee

let overlaylook=null
let checkballcolor=false
let removeballaction=false
let moveballdownaction=false //移动球到空格
let alignballaction=false
let switchballaction=false
let insertnewball=false //插入新的球
let switchball=false  //拖动交换球
let movingballdown=false

let touchtarget=null
let touchendtarget=null
let touchmovexy=[0,0]
let switchdir=''


let effecterballa=null
let effecterA_enable=true
let effecterA_num=null
let effectotboom=false
let effectbonus=false


let global_rotation_z=0 
let global_shake_rotate_z=0
let global_shake_val_p=10



//install setting
let totalstep=30
let targetnum=5
let maxnum=9
let collect=30
let Gamefinish=false
let showendcard=false
let restartgame=false
let randnum=[]
let randnum_pare=[]
let intdata=false


let numpool=[0,1,2,3,4,5,6,7,8,9,10,11,15,20,22]
let tanumpool=[3,4,5,8,10,11,15,20,22]



let Gamestart=false

let controlblockarray= []


function create2DArray(rows, cols, defaultValue) {
    return Array.from({ length: rows }, () => Array.from({ length: cols }, () => defaultValue));
  }


function Cubeitem({...props}){
    const { camera, size } = useThree();
    const itemref = useRef()
    const meshref= useRef()
    const nummeshref = useRef()
    const effectref= useRef()
    const particleref = useRef()
    const [isnotblock,setisnotblock]=useState(props.cubetype.notblock)
    const [effectora,seteffectora]=useState(false)
    const [effectorc,seteffectorc]=useState(false)
    const [showpartical,setshowpartical]=useState(false)
    const [effecterCpartical,seteffecterCpartical]=useState(false)
     
    const store = useStore()

    let glasealpha=1
    let sideset=THREE.FrontSide

    if(Android){
      glasealpha=1
      sideset=THREE.BackSide
    }
   
    let nummodelcode=6

    if(props.cubetype.Num==targetnum){

      nummodelcode=7
    }


    const { nodes,materials } = useGLTF(hostloca+'models/num'+nummodelcode+'.glb')
    
   
    const [linecolorMap,alphamap] = useLoader(THREE.TextureLoader, [
      hostloca+'models/emisstionmap.jpg', // 颜色纹理路径
      hostloca+'models/stonemap10.jpg', // 颜色纹理路径
    ]);
    

    const sphereGeometry = useMemo(() => new THREE.SphereGeometry(1, 15, 15), []);  

    const IcosahedronGeometry = useMemo(() => new THREE.IcosahedronGeometry(2.4), []);  

    let geoshape=sphereGeometry

    let numtag=props.cubetype.Num
  
    let numgeo=nodes['num'+numtag].geometry

    let diappemissiveIntensity=0
    let ballscale=1
    let counteffecter=40


    useEffect(() => {


      if(props.effecterA){

        // numgeo=IcosahedronGeometry
        seteffectora(true)
       }else{
        seteffectora(false)
       }

       if(props.effecterC){

        // numgeo=IcosahedronGeometry
        seteffectorc(true)
       }else{
        seteffectorc(false)
       }
       

      const glassblockmaterial0 = new THREE.MeshPhysicalMaterial({ color: '#fff',transparent:true,opacity:glasealpha,transmission:1,ior:1,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial1 = new THREE.MeshPhysicalMaterial({ color: '#e7e7e7',transparent:true,opacity:glasealpha,transmission:1,ior:1,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity,side:sideset});
       
        const glassblockmaterial2 = new THREE.MeshPhysicalMaterial({ color: '#aec5ff',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial3 = new THREE.MeshPhysicalMaterial({ color: '#fff',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial4= new THREE.MeshPhysicalMaterial({ color: '#d7deff',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});
        
        const glassblockmaterial5= new THREE.MeshPhysicalMaterial({ color: '#e4e0ff',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial6= new THREE.MeshPhysicalMaterial({ color: '#e4e0ff',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial7= new THREE.MeshPhysicalMaterial({ color: '#d0e5f9',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});

        const glassblockmaterial8= new THREE.MeshPhysicalMaterial({ color: '#ff923a',transparent:true,opacity:glasealpha,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'#fff',emissiveIntensity:diappemissiveIntensity});


      
        
        const glassblockmaterial1_boom = new THREE.MeshPhysicalMaterial({ color: '#e7e7e7',transparent:true,opacity:1,transmission:1,ior:1,envMapIntensity:10,roughness:0,emissiveMap:linecolorMap,emissive:'#fff',emissiveIntensity:10,alphaMap:linecolorMap});


        const glassblockmaterial9= new THREE.MeshPhysicalMaterial({ color: 'white',transparent:true,opacity:1,transmission:1,ior:1.12,envMapIntensity:10,roughness:0,emissive:'white',emissiveIntensity:1});

        

        const plasticmaterial2 = new THREE.MeshStandardMaterial({ color:'white',roughness:0,metalness:0 ,emissive:'white',emissiveIntensity:5});

        const plasticmaterial1 = new THREE.MeshStandardMaterial({ color: 'red',roughness:0,metalness:0 ,emissive:'red',emissiveIntensity:3});

        const plasticmaterial3 = new THREE.MeshStandardMaterial({ color:'#ffdca5',roughness:0,metalness:0 ,emissive:'white',emissiveIntensity:0,envMapIntensity:5,metalness:.7});
        const plasticmaterial4 = new THREE.MeshStandardMaterial({ color:'#fff',roughness:0.2,emissive:'white',emissiveIntensity:0,envMapIntensity:4,metalness:.8,wireframe:false,wireframeLinewidth:.2,side:THREE.BackSide})

        //const plasticmaterial4 = new THREE.MeshPhysicalMaterial({ color: '#red',transparent:true,opacity:1,transmission:0,ior:1,envMapIntensity:10,roughness:0});

        const blockmaterial= new THREE.MeshPhysicalMaterial({    color: '#ccc',transparent:true,opacity:1,transmission:1,ior:1.42,envMapIntensity:2,roughness:0.4,metalness:.1});
        const plasticmaterialalpha = new THREE.MeshStandardMaterial({ color:'#fff',transparent:true,opacity:0});
        const plasticmaterialwhite = new THREE.MeshStandardMaterial({ color:'#b5d0df',roughness:0 });


        if (meshref.current) {

            meshref.current.scale.set(1,1,1)
            meshref.current.rotation.set(Math.PI/2,0,0)

          if(props.block){
           //先判断是否冻结对象
            meshref.current.material= plasticmaterialalpha
            nummeshref.current.material= plasticmaterialalpha
            if(effectora){
              effectref.current.material= plasticmaterialalpha
              
             }

             setshowpartical(false)
             seteffecterCpartical(false)
          }else{


            nummeshref.current.material= plasticmaterial2
        
            if(props.cubetype.shape==2){
              meshref.current.material= blockmaterial
              nummeshref.current.material= plasticmaterialalpha
            }else  if(props.cubetype.shape==3){
              meshref.current.material= plasticmaterialalpha
              nummeshref.current.material= plasticmaterialalpha
            }else{

                meshref.current.material= glassblockmaterial1
                nummeshref.current.material= plasticmaterial2



                 

                    if(props.effecterC){
                    
                      meshref.current.material= glassblockmaterial1_boom
 
                      
                   }

                   if(props.effecterC_pro){
                    seteffecterCpartical(true)
                  }
                 
                      

                   //消除激发状态动画
                  
                    if(props.mark){
                      setshowpartical(true)
                     
                      
                    }else{

                      setshowpartical(false)
                      
                     // setdiappemissiveIntensity(0)
                    }

                  

                    if(effectora){
                      effectref.current.material= plasticmaterial4

                    
                     }

  
                     

                   

            }

             // if(props.cubeindex==6){
             //   meshref.current.material= glassblockmaterial9
              //  nummeshref.current.material= plasticmaterial2
                
            //  }
            }


            }

    

        // 当组件卸载时，清理材质资源
        return () => {
            meshref.current.material.dispose();
        };
       
     }, [props]);


     useFrame(() => {

    

        if(nummeshref.current && itemref.current) {


            //close effecter

        if(counteffecter>0){
          counteffecter-=1
         
        }else{
         
          if(effecterCpartical){
           // console.log('1111111111111111111')
            seteffecterCpartical(false)
          }

        }


 

          if(effectora){
            effectref.current.rotation.z = global_rotation_z
            
           }

           
           if(effectorc){

            meshref.current.rotation.x = global_rotation_z

          
 
            
         }

         if(props.mark==true &&  showpartical){
          
          
              if(diappemissiveIntensity<1){
                diappemissiveIntensity+=.1
              }else{
                particleref.current.scale.set([0,0,0])
                }
                
              meshref.current.material.emissiveIntensity=diappemissiveIntensity

              if(ballscale>.1)ballscale-=.03
              meshref.current.scale.set(ballscale,ballscale,ballscale)

             // if(itemref.current.parent.position.z<=-12 ){
              
             // }

            
         } 

       


/*
      const campos=new THREE.Vector3(camera.position.x,-camera.position.z,camera.position.y)
          //  const cameraPositionLocal = itemref.current.worldToLocal(camera.position.clone());
          // const campos=new THREE.Vector3(-camera.position.x ,-camera.position.y ,-camera.position.z )

          // 假设camera是你的相机对象
                    const cameraPosition = camera.position; // 相机的当前位置

                    // 由于原点是(0, 0, 0)，相机位置向量即是相机到原点的向量
                    const upVector = new THREE.Vector3(0, 1, 0); // 用于计算绕x轴旋转的向量（俯仰）
                    const rightVector = new THREE.Vector3(1, 0, 0); // 用于计算绕y轴旋转的向量（偏航）
                    const forwardVector = new THREE.Vector3(0, 0, -1); // 用于计算绕z轴旋转的向量（翻滚），Three.js中前方通常为负z方向

                    // 计算相机位置向量与各轴正方向之间的夹角（弧度）
                    const pitchAngle = cameraPosition.angleTo(upVector); // 绕x轴
                    const yawAngle = cameraPosition.angleTo(rightVector); // 绕y轴
                    const rollAngle = cameraPosition.angleTo(forwardVector); // 绕z轴

                        // 欧拉角
                        const euler = new THREE.Euler(pitchAngle, yawAngle, rollAngle, 'XYZ');
                       // itemref.current.rotation.set(euler.x,-euler.y,euler.z)
                        
         //  nummeshref.current.lookAt(campos)
         */
        }
        
      });

       
      
     /**
      * 
      * 拖动事件
      */

     

      const ontouch = useCallback((event) => {
        
        if(switchball==false){
        //不能直接引用props中的 pare 或 tempmatch 需要在原始数组中再定位一次
        let paread=props.pare
        let matchparead=props.tempmatch 
      
       // console.log('drag'+tempcubearray[sourcepoint[0]][sourcepoint[1]].number)//原始对象数组
       // cubeObjarray[paread[0]][paread[1]].position.z=-12//三维对象
       
        touchtarget=cubearray[matchparead[0]][matchparead[1]].tempmatch//对应参照数组的锚点坐标
       //  console.log(touchtarget) 

        //对应参照数组的数值
           let sourcepoint=cubearray[matchparead[0]][matchparead[1]].tempmatch
           // console.log(tempcubearray[sourcepoint[0]][sourcepoint[1]].effecterA)  
            console.log(tempcubearray[sourcepoint[0]][sourcepoint[1]].number)  
            
         //获取当前触点坐标
        
         const { offsetX, offsetY } = event.nativeEvent;
        
         touchmovexy=[offsetX,offsetY]

         if(!store.touch){
          store.touch=true
           
        }

         }
        }, [])


        const ontouchout= useCallback((event) =>{ 
          
         

        }, [])

        function ontouchleave(e){
          if(store.touch){
            store.touch=false
            
          }


        }
    
      const ontouchup = useCallback((event) =>{ 
        
         if(touchtarget!=null){
         const containsKt = controlblockarray.some(subArray => 
          subArray.length === touchtarget.length && subArray.every((element, index) => element === touchtarget[index])
          );

          if(containsKt){

            //冻结对象 不进行操作
          }else{
 

            if(switchball==false){
            //计算拖动方向
            const { offsetX, offsetY } = event.nativeEvent;
            
            let dir=null
            let hd=offsetX-touchmovexy[0]
            let vd=offsetY-touchmovexy[1]
 

       
            if(hd> 4){
              if(touchtarget[1]+1 < 8 && tempcubearray[touchtarget[0]][touchtarget[1]+1].block)return
                dir='right'
                switchball=true
                switchballmove(dir)
            }else if(hd < -4){
               if(touchtarget[1]-1 >= 0 && tempcubearray[touchtarget[0]][touchtarget[1]-1].block)return
                dir='left'
                switchball=true
                switchballmove(dir)

               
            }else if
            (vd> 4){
              if(touchtarget[0]+1 < 8 && tempcubearray[touchtarget[0]+1][touchtarget[1]].block)return
                dir='down'
                switchball=true
                switchballmove(dir)
            }else if(vd < -4){
              if(touchtarget[0]-1 >= 0 && tempcubearray[touchtarget[0]-1][touchtarget[1]].block)return
                dir='up'
                switchball=true
                switchballmove(dir)
            }

              
           
           
           
          }


        }
      }

       
       }, [])

     return (
        <a.group ref={itemref} {...props} dispose={null} onPointerDown={ontouch}  onPointerMove={ontouchup}  onPointerOut={ontouchout} onPointerLeave={ontouchleave} >
         <mesh ref={meshref}   scale={[1,1,1]} geometry={geoshape}>
       
  
         </mesh>

             <mesh ref={nummeshref}   scale={[1.4,1.4,1.4]} rotation={[0,0,0]} geometry={numgeo}>

            </mesh>

            

            {effectora? (
              
             <mesh ref={effectref}   scale={[.36,.36,.36]} rotation={[0,0,0]} geometry={IcosahedronGeometry}>

             </mesh>
               ):('')}

            {showpartical? (


                    <mesh  ref={particleref}  position={[0, 1, 0]} rotation={[-Math.PI/2,0,0]}>
                      <planeGeometry args={[2, 2]} />
                      <meshStandardMaterial color="royalblue"  transparent={true} opacity={0}/>


                      <Html scaleFactor={1}  scale={[1,1,1]}  position={[0, 0, 0]} transform>
            

                              <div 
                              className="sprite-animation"

                          
                              style={{
                                width:250,
                                height: 250,
                              //  backgroundColor:'red',
                                color:'white',
                                fontSize:'14px',
                                left:-125,
                                top:-125,
                                opacity:1,
                                position:'absolute',
                                backgroundImage: 'url('+hostloca+'Assets/boomsheet.png)',
                                backgroundSize: `${10 * 140}% ${250}px`, // 1000% of div width
                                animation: 'sprite-animation 1s steps(14)'
                              
                              }}>
            
                        </div>

                        
                  
                    </Html>



                      </mesh>

            ):('')}



                  {effecterCpartical? (


                  <mesh  ref={particleref}  position={[0, .1, 0]} rotation={[-Math.PI/2,0,0]}>
                    <planeGeometry args={[2, 2]} />
                    <meshStandardMaterial color="royalblue"  transparent={true} opacity={0}/>


                    <Html scaleFactor={1}  scale={[1,1,1]}  position={[0, 0, 0]} transform>


                            <div 
                            className="sprite-animation"

                        
                            style={{
                              width:300,
                              height: 300,
                            //  backgroundColor:'red',
                              color:'white',
                              fontSize:'14px',
                              left:-152,
                              top:-142,
                              opacity:1,
                              position:'absolute',
                              backgroundImage: 'url('+hostloca+'Assets/efsheet1.png)',
                              backgroundSize: `${10 * 150}% ${300}px`, // 1000% of div width
                              animation: 'sprite-animation_ef 1s steps(15) infinite'
                            
                            }}>

                      </div>

                    
                        
                  </Html>



                    </mesh>

                  ):('')}

          

      </a.group>

    )
     


}
 


function switchballmove(dir){


  
   let  timert=200
    
   if(touchtarget){


    switchballaction=true
    alignballaction=false
    switchdir=dir

    touchendtarget=null //最终Three obj坐标

    let clonetempcubearray = JSON.parse(JSON.stringify(tempcubearray));
    let tac=touchtarget
    let taa=null
    let tab=null
    let tasL=tac[1]-1
    let tasR=tac[1]+1
    let tasU=tac[0]-1
    let tasD=tac[0]+1
    if(dir=='left' && tasL>=0){
            taa=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tac[1]]));
            tab=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tasL]));

            clonetempcubearray[tac[0]][tac[1]]=tab
            clonetempcubearray[tac[0]][tasL]=taa
    }else if(dir=='right' && tasR<8){
            taa=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tac[1]]));
            tab=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tasR]));

            clonetempcubearray[tac[0]][tac[1]]=tab
            clonetempcubearray[tac[0]][tasR]=taa
     }else if(dir=='up' && tasU>=0){
            taa=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tac[1]]));
            tab=JSON.parse(JSON.stringify(clonetempcubearray[tasU][tac[1]]));

            clonetempcubearray[tac[0]][tac[1]]=tab
            clonetempcubearray[tasU][tac[1]]=taa

     }else if(dir=='down' && tasD<8){
            taa=JSON.parse(JSON.stringify(clonetempcubearray[tac[0]][tac[1]]));
            tab=JSON.parse(JSON.stringify(clonetempcubearray[tasD][tac[1]]));

            clonetempcubearray[tac[0]][tac[1]]=tab
            clonetempcubearray[tasD][tac[1]]=taa
     }

    
      /* 参照组测试 */
      /*
       let testmark=create2DArray(8,8,0)
       let testmarksource=create2DArray(8,8,0)

      for(let l=0;l<8;l++){
        for(let m=0;m<8;m++){
            let sp=tempPareSourcearray[l][m] //获取指针
            testmark[l][m]=tempcubearray[l][m].number
            testmarksource[l][m]= clonetempcubearray[l][m].number  
 
            
        }
      } 


      console.log(testmark)
      console.log(testmarksource)
       */
       

      let checkmark=detectAndMarkMatches(clonetempcubearray,true)

     //  console.log(checkmark)

       if(checkmark && deleteProcess==false){
           //匹配成功，更新参照矩阵数组
       
           timert=20
            //更新Three object指针位置
            if(dir=='left' && tasL>=0){
               
              let taa=tempcubeObjmark[tac[0]][tac[1]]
              let tab=tempcubeObjmark[tac[0]][tasL]
              tempcubeObjmark[tac[0]][tac[1]]=Array.from(tab) 
              tempcubeObjmark[tac[0]][tasL]=Array.from(taa)

              let t2pa=Array.from(tempPareSourcearray[tac[0]][tac[1]])
              let t2pb=Array.from(tempPareSourcearray[tac[0]][tasL])
              tempPareSourcearray[tac[0]][tac[1]]=t2pb
              tempPareSourcearray[tac[0]][tasL]=t2pa

               touchendtarget=[tac[0],tasL]
              
          }else if(dir=='right' && tasR<8){
              let taa=tempcubeObjmark[tac[0]][tac[1]]
              let tab=tempcubeObjmark[tac[0]][tasR]
              tempcubeObjmark[tac[0]][tac[1]]=Array.from(tab) 
              tempcubeObjmark[tac[0]][tasR]=Array.from(taa)

              let t2pa=Array.from(tempPareSourcearray[tac[0]][tac[1]])
              let t2pb=Array.from(tempPareSourcearray[tac[0]][tasR])
              tempPareSourcearray[tac[0]][tac[1]]=t2pb
              tempPareSourcearray[tac[0]][tasR]=t2pa

               touchendtarget=[tac[0],tasR]
                  
          }else if(dir=='up' && tasU>=0){
              let taa=tempcubeObjmark[tac[0]][tac[1]]
              let tab=tempcubeObjmark[tasU][tac[1]]
              tempcubeObjmark[tac[0]][tac[1]]=Array.from(tab) 
              tempcubeObjmark[tasU][tac[1]]=Array.from(taa)

              let t2pa=Array.from(tempPareSourcearray[tac[0]][tac[1]])
              let t2pb=Array.from(tempPareSourcearray[tasU][tac[1]])
              tempPareSourcearray[tac[0]][tac[1]]=t2pb
              tempPareSourcearray[tasU][tac[1]]=t2pa

               touchendtarget=[tasU,tac[1]]
      
          }else if(dir=='down' && tasD<8){
              let taa=tempcubeObjmark[tac[0]][tac[1]]
              let tab=tempcubeObjmark[tasD][tac[1]]
              tempcubeObjmark[tac[0]][tac[1]]=Array.from(tab) 
              tempcubeObjmark[tasD][tac[1]]=Array.from(taa)
               
              let t2pa=Array.from(tempPareSourcearray[tac[0]][tac[1]])
              let t2pb=Array.from(tempPareSourcearray[tasD][tac[1]])
              tempPareSourcearray[tac[0]][tac[1]]=t2pb
              tempPareSourcearray[tasD][tac[1]]=t2pa

               touchendtarget=[tasD,tac[1]]
          }

          

          //扣除步数
         
          if(totalstep>0){
            totalstep -=1
           }
            

        //  console.log('touch end target: '+ clonetempcubearray[touchendtarget[0]][touchendtarget[1]].number)

  
         //更新原始对象数组锚点坐标 用来反向索引参考坐标的位置 ????
         // cubearray[tempPareSourcearray[tac[0]][tac[1]][0]][tempPareSourcearray[tac[0]][tac[1]][1]].tempmatch=[tac[0],tac[1]]   

 
         
          
         
            //匹配删除
            const fwia= setTimeout(() => {
              tempcubearray= JSON.parse(JSON.stringify(clonetempcubearray));
              detectAndMarkMatches(tempcubearray,false)
            }, 600);

          }else{
              //没有匹配成功，单纯触发动画
               
          
          }


          
          }


        setTimeout(() => {
          alignballaction=true
          switchballaction=false
          switchball=false
          touchtarget=null //防止多次点击
          
          }, timert);
      

   

    
     
 }

  


 

  function gencolor(){
    const hue = Math.random(); // 0到1之间的随机数，代表色相
    const saturation = 0.4; // 低饱和度，你可以根据需要调整这个值
    const lightness = 0.1 + Math.random() * 0.5; // 亮度，这里选择了0.5到1之间的随机亮度，以避免太暗的颜色

    const randomColor = new THREE.Color().setHSL(hue, saturation, lightness);

    return randomColor
  }

  function findUniqueNumbers(matrix) {
    const uniqueNumbers = new Set();

    // 遍历二维数组的每个元素
    for (const row of matrix) {
        for (const item of row) {
          uniqueNumbers.add(item);
        }
    }
 

    // 将Set转换为数组并返回
    return Array.from(uniqueNumbers);
}


function findUniqueNumberspare(matrix) {
  const uniqueNumbers = new Set();
  // 遍历二维数组的每个元素
  for (const row of matrix) {
      for (const item of row) {         
        let parenum=numpool[item]
      uniqueNumbers.add(parenum);
      }
  }
   // 将Set转换为数组并返回
   return Array.from(uniqueNumbers);
  }


  
  function generateBoard(numElements) {
    const board = [];
    const selectedNumbers = chooseRandomNumbers(1, numElements, 5); // 从1到numElements选择5个数字
  
    for (let i = 0; i < 8; i++) {
        let row = [];
        for (let j = 0; j < 8; j++) {
            let num;
            do {
                num = selectedNumbers[Math.floor(Math.random() * selectedNumbers.length)];
            } while ((j >= 2 && num === row[j-1] && num === row[j-2]) ||
                     (i >= 2 && num === board[i-1][j] && num === board[i-2][j]));
            row.push(num);
        }
        board.push(row);
    }
    return board;
  }
  
  // 辅助函数：从指定范围选择指定数量的唯一数字
  function chooseRandomNumbers(min, max, count) {
    const numbers = [];
    while (numbers.length < count) {
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) {
            numbers.push(num);
        }
    }
    return numbers;
  }


  function intersectArrays(array1, array2) {
    // 使用filter方法来找出第一个数组中那些也存在于第二个数组的元素
    const intersection = array1.filter(element => array2.includes(element));
    return intersection;
  }

function removeConsecutiveTriples(board, numElements) {
  let foundTriple = true;
  while (foundTriple) {
      foundTriple = false;
      for (let i = 0; i < 8; i++) {
          for (let j = 0; j < 8; j++) {
              // 生成一个除当前值外的随机数字数组
              let validValues = Array.from({length: numElements}, (_, k) => k + 1).filter(v => v !== board[i][j]);
              if (j < 6 && board[i][j] === board[i][j + 1] && board[i][j + 1] === board[i][j + 2]) {
                  board[i][j + 2] = validValues[Math.floor(Math.random() * validValues.length)];
                  foundTriple = true;
              }
              if (i < 6 && board[i][j] === board[i + 1][j] && board[i + 1][j] === board[i + 2][j]) {
                  board[i + 2][j] = validValues[Math.floor(Math.random() * validValues.length)];
                  foundTriple = true;
              }
          }
      }
  }
  return board;
}


  function genballs(type,num){
    const itemtypes=[
      {color:'#fff',Num:0,map:hostloca+'Assets/6.png',texturetype:2,shape:0,txtcolor:'white',notblock:true},
      {color:'#777',Num:1,map:hostloca+'Assets/1.png',texturetype:0,shape:0,txtcolor:'white',notblock:true},
      {color:'#000000',Num:2,map:hostloca+'Assets/2.png',texturetype:3,shape:1,txtcolor:'white',notblock:true},
      {color:'#1F5BFF',Num:3,map:hostloca+'Assets/3.png',texturetype:1,shape:0,txtcolor:'white',notblock:true},
      {color:'#fff',Num:4,map:hostloca+'Assets/4.png',texturetype:6,shape:0,txtcolor:'black',notblock:true},
     {color:'#FC470F',Num:5,map:hostloca+'Assets/5.png',texturetype:5,shape:1,txtcolor:'white',notblock:true},

     {color:'#FC470F',Num:6,map:hostloca+'Assets/6.png',texturetype:2,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:7,map:hostloca+'Assets/7.png',texturetype:0,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:8,map:hostloca+'Assets/8.png',texturetype:3,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:9,map:hostloca+'Assets/9.png',texturetype:1,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:10,map:hostloca+'Assets/10.png',texturetype:6,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:11,map:hostloca+'Assets/11.png',texturetype:5,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:15,map:hostloca+'Assets/11.png',texturetype:5,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:20,map:hostloca+'Assets/11.png',texturetype:5,shape:1,txtcolor:'white',notblock:true},
     {color:'#FC470F',Num:22,map:hostloca+'Assets/11.png',texturetype:5,shape:1,txtcolor:'white',notblock:true},


    //  {color:'#FC470F',Num:6,map:hostloca+'Assets/7.png',texturetype:4,shape:1,txtcolor:'black',notblock:true},
    //  {color:'#FC470F',Num:9,map:hostloca+'Assets/9.png',texturetype:6,shape:2,txtcolor:'black',notblock:false},
    //  {color:'#FC470F',Num:9,map:hostloca+'Assets/9.png',texturetype:10,shape:3,txtcolor:'black',notblock:false},
   //   {color:'#FC470F',Num:9,map:hostloca+'Assets/9.png',texturetype:7,shape:0,txtcolor:'black',notblock:true},
     // {color:'#FC470F',Num:9,map:hostloca+'Assets/9.png',texturetype:8,shape:0,txtcolor:'black',notblock:true}
   ]


    if(type==true){
 
     let randomtype=Math.floor(Math.random() * (num))+1
     
     return itemtypes[randomtype]
    }else{
    
      return itemtypes[num]

    }

  }



function Cubeplanel(props){
    const [cubegroup,setcubegroup]=useState([])
    const [showballsitems,setshowballsitems]=useState(false)
    const [cubegrouptemp,setcubegrouptemp]=useState([])
    const [poseall,setposeall]=useState(false)

    const { gl  } = useThree();

    const ballscontainer= useRef()
        // 使用useState初始化一个数组，用于存储对每个盒子的引用
    
    // const cuberefs=useRef(cuberandom.map(() => React.createRef()))
     const objectRefs = useRef([]);

     const store = useStore()

   
    let shifleft=-9.4
    let shiftop=-10.8
    let cubesize=2.7
    let cubex =shifleft
    
    let rows=8
    let cols=8

    useEffect(() => {

        if(!intdata){

            intdata=true
          
             //生成初始矩阵及随机收集数字
              maxnum=14   
             
         
           let initialBoard = generateBoard(maxnum);
          initialBoard = removeConsecutiveTriples(initialBoard,maxnum);
           
                           
        
          randnum=findUniqueNumbers(initialBoard)
           //really num
          randnum_pare=findUniqueNumberspare(initialBoard)

          
          //将随机生成的数组和，目标可用数组相交得到新数组
          let newtargetnum=intersectArrays(randnum_pare,tanumpool)
          let randomchoose=Math.floor(Math.random() * newtargetnum.length)  
            //choose target num
            let creattanum=newtargetnum[randomchoose]
          //极限情况完全没有匹配 
          if(newtargetnum.length==0){
            creattanum=randnum_pare[2]
          } 

          targetnum= creattanum
     
          store.num=targetnum
     
           
          console.log(initialBoard)
          console.log(randnum)
          console.log(randnum_pare)
          console.log(newtargetnum)
         for(var j=0;j<rows;j++){
 

            for(var i=0;i<cols;i++){
 
                        cubex = shifleft+i*cubesize
                  
                        let cubez=shiftop +cubesize*j
                        let cubey=0
                       // let randomtype=Math.floor(Math.random() * (itemtypes.length-4))
                        let balltype=genballs(false,initialBoard[j][i])

                        //let balltype=genballs(true,5)
                      
                      
                    
                        let kt=[j,i]
                        let blockball=false
                         // 使用some和every方法检查kt是否为controlBlockArray的一个子数组
                        const containsKt = controlblockarray.some(subArray => 
                        subArray.length === kt.length && subArray.every((element, index) => element === kt[index])
                        );

                        if(containsKt){
                         
                          blockball=true
                        }

                       


                        const cubeitem={scale:1.2,pare:[j,i],tempmatch:[j,i],number:balltype.Num,type:balltype,mark:true,block:blockball,effecterC:false,effecterA:false,effecterC_pro:false}    
                        cuberandom[j][i]=cubeitem
                        cubeposearray[j][i]=[cubex,cubey,cubez]
                        tempPareSourcearray[j][i]=[j,i] //矩阵参照数组

            }

         }

        setcubegroup(cuberandom)
         cubearray= JSON.parse(JSON.stringify(cuberandom));
         tempcubearray=JSON.parse(JSON.stringify(cuberandom));
         console.log(tempcubearray)
       

        setposeall(true)//set possition
        setshowballsitems(true)
        
        console.log('inistall balls group')

      
        }
    
         
      }, [props]);


      useEffect(() => {
        if(poseall){
            setposeall(false)
      
        if(objectRefs.current.length>0){

           for(let j=0;j<8;j++){
            for(let i=0;i<8;i++){

                cubeObjarray[j][i]=objectRefs.current[j][i]
                cubeObjarray[j][i].position.set(cubeposearray[j][i][0],cubeposearray[j][i][1],cubeposearray[j][i][2])
                tempcubeObjmark[j][i]=[j,i] //三维对象位置参照
                cubearray[j][i].mark=false
                tempcubearray[j][i].mark=false
            }

           }

           setcubegroup(cubearray) //??
 
          

           
        }
          
          
        console.log('render balls 8x8')
        setTimeout(() => {
            moveballdownaction=true
            introanimate=true
            gl.setPixelRatio(1);
            store.startgame=1
            store.gamestate=2
            console.log('Start Game!')
             
           
      
        }, 2400);
 
    }
       

      },[poseall])




 

      useEffect(() => {
        console.log('group change')

       
      //  console.log(cubegroup); // 这会在cubegroup更新后执行
      }, [cubegroup]); 

      useFrame(({ viewport, camera, pointer,clock}, delta) => {






        if(objectRefs.current.length>0){

         
 
           //Intro animation======================
        if(camera.position.y !=49  && introanimate==true  && !Gamefinish  && store.loaded==true){
          
                Gamestart=true
                easing.damp3(camera.position, [0,49,0], 1.5, delta)
                easing.damp3(camera.rotation, [-1.57,-6.2825,0], 1.5, delta)
                if(  store.startgame!=1)  store.startgame=1

                if(camera.position.y==49){
                  introanimate=false
                  console.log('intro animation stop')
                }
         
          }else{

               

               if(Gamestart && !Gamefinish){
                
               if(camera.position.z !=0){
                easing.damp3(camera.position, [0,49,0], .1, delta)
              
               }
               }

           
          }

            /**
             * 结束游戏
             */

         
          //End game animation======================

          if(Gamefinish   ){
           

            easing.damp3(camera.position, [0,89,-40], .8, delta)
            easing.damp3(camera.rotation, [-1.17,-6.30825,0], .8, delta)

            store.startgame=0
            
              if(showendcard!=true){
                //change dpr
                gl.setPixelRatio(.5);
                console.log('recive dpr')

                showendcard=true
                setTimeout(() => {
                  store.endgame = 1
                
                }, 1000);
                console.log('Game End!!!')
            }

            /**
             * 重启游戏
             */

            //restart game=============================

                    if(restartgame){
                     
                      Gamefinish=false
                      introanimate=true
                      store.endgame = 0


                      totalstep=30
                      collect=30
                      showendcard=false
                      store.count =0
                      store.step  =totalstep
                      store.collect=collect

                          

                      //清除所有特效

                      let eresetcubegroup= JSON.parse(JSON.stringify(cubearray));//复制一份原始对象数组 避免直接操作
                      for(let j=0;j<8;j++){
                        for(let i=0;i<8;i++){
                           
                               
                                   let pinadress=tempPareSourcearray[j][i] //匹配矩阵
                                   tempcubearray[j][i].mark=false 
                                   eresetcubegroup[pinadress[0]][pinadress[1]].mark=false //更新对象数组
                                    
                                   //如果消除对象是特殊效果对象则清除特殊效果标记
                                   eresetcubegroup[pinadress[0]][pinadress[1]].effecterC=false
                                   tempcubearray[j][i].effecterC=false 
            
                                   //effecterC起始动画标记clear & set
                                   eresetcubegroup[pinadress[0]][pinadress[1]].effecterC_pro=false
                                   tempcubearray[j][i].effecterC_pro=false 
            
                                   eresetcubegroup[pinadress[0]][pinadress[1]].effecterA=false
                                   tempcubearray[j][i].effecterA=false 
    
                        }
                      }

                        setcubegroup(eresetcubegroup) //赋值
                        cubearray=eresetcubegroup

                        console.log('Game reset!!!')

                      restartgame=false
                    } 

          }


         //rotation shake animation======  
        
                  
          global_rotation_z +=0.01

          const et = clock.elapsedTime
          
          global_shake_rotate_z= Math.sin((et  * 4) / 3) / global_shake_val_p

          ballscontainer.current.rotation.z =global_shake_rotate_z
          ballscontainer.current.rotation.x =global_shake_rotate_z/2

          if( global_shake_val_p < 10){
            global_shake_val_p+=1
          }else{
            global_shake_val_p=10
          }
         
          /* 
          if(overlaylook!=null){
            // objectRefs.current[40].rotation.set(overlaylook.rotation.x,overlaylook.rotation.y,overlaylook.rotation.z)


             objectRefs.current.map((itemobj) => (
              itemobj.rotation.set(-overlaylook.rotation.x,overlaylook.rotation.y,-overlaylook.rotation.z)
             ))
          
          } */
        
 

           /**
            * 通过参照数组比对，然后基于匹配矩阵删除原始对象数组的内容，
            */
          
          
           if(removeballaction){

            let collectmark=[]
         
           let resetcubegroup= JSON.parse(JSON.stringify(cubearray));//复制一份原始对象数组 避免直接操作
           for(let j=0;j<8;j++){
            for(let i=0;i<8;i++){
               
                    if(tempcubearray[j][i].mark == true ||  tempcubearray[j][i].number==effecterA_num){
                       let pinadress=tempPareSourcearray[j][i] //匹配矩阵
                     
                       resetcubegroup[pinadress[0]][pinadress[1]].mark=true //更新对象数组
                        
                       //如果消除对象是特殊效果对象则清除特殊效果标记
                       resetcubegroup[pinadress[0]][pinadress[1]].effecterC=false
                       tempcubearray[j][i].effecterC=false 

                       //effecterC起始动画标记clear & set
                       resetcubegroup[pinadress[0]][pinadress[1]].effecterC_pro=false
                       tempcubearray[j][i].effecterC_pro=false 

 

                       resetcubegroup[pinadress[0]][pinadress[1]].effecterA=false
                       tempcubearray[j][i].effecterA=false 

                       //cllection math计算收集数字得分 
                       /**
                        * 特殊效果消除未计算在内
                        */
                       if(tempcubearray[j][i].number==targetnum && collect>0){
                        collect-=1
                        collectmark.push([j,i])
                        
                       if( collect== 0 && !Gamefinish){
                          setTimeout(() => {
                            Gamefinish=true
                          }, 500);
                       }

                       }
                    }
                }
            }


            if(effecterballa!=null){
              let efta=tempPareSourcearray[effecterballa[0]][effecterballa[1]]
              resetcubegroup[efta[0]][efta[1]].effecterC_pro=true
              tempcubearray[effecterballa[0]][effecterballa[1]].effecterC_pro=true

              if(!store.effectc)store.effectc=true
             } 


              //souneffect boom
              if( effectotboom==true && store.boom==false){
                store.boom=true
                effectotboom=false
               }

               if( effectbonus==true && store.bonus==false){
                store.bonus=true
                effectbonus=false
               }
 
           
           setcubegroup(resetcubegroup) //赋值

           if(!Gamefinish){

           store.count +=deletemark.length
            
            
            store.mark=collectmark
            store.step  =totalstep
           
            store.collect=collect
           }

             /**
              * 步数扣除结束游戏
              */

            if(totalstep==0 && !Gamefinish){

                  setTimeout(() => {
                    Gamefinish=true
                  }, 500);
            }
            
            

            effecterA_num=null //重置effecterA_num数字

            //震动画面
            if(Gamestart && !Gamefinish){
             easing.damp3(camera.position, [0,49,-3], .1, delta)
            }
            

            //reset and update ball 8x8
            removeballaction=false
           }

           //move ball position action
           /**
            * 移动三维对象
            */
           if(moveballdownaction && insertnewball==false){
                 if(alignballaction){
                  
                    for(let l=0;l<8;l++){
                        for(let m=0;m<8;m++){
                           // cubeObjarray[tempcubeObjmark[l][m][0]][tempcubeObjmark[l][m][1]].position.set(cubeposearray[l][m][0],cubeposearray[l][m][1],cubeposearray[l][m][2]) //移动三维对象

                            easing.damp3(cubeObjarray[tempcubeObjmark[l][m][0]][tempcubeObjmark[l][m][1]].position, [cubeposearray[l][m][0],cubeposearray[l][m][1], cubeposearray[l][m][2]], 0.1, delta)

                        }
                    }

                    

                  }

                  if(switchballaction && touchtarget!=null){

                   // console.log(touchtarget)

                    let tas=touchtarget
                    let tasL=tas[1]-1
                    let tasR=tas[1]+1
                    let tasU=tas[0]-1
                    let tasD=tas[0]+1
          
                    
                     if(switchdir=='left'){
                        if(tasL>=0){
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tas[1]][0]][tempcubeObjmark[tas[0]][tas[1]][1]].position, [cubeposearray[tas[0]][tasL][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tasL][0]][tempcubeObjmark[tas[0]][tasL][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                        }
                       
                    }else if(switchdir=='right'){
                        if(tasR<8){
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tas[1]][0]][tempcubeObjmark[tas[0]][tas[1]][1]].position, [cubeposearray[tas[0]][tasR][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tasR][0]][tempcubeObjmark[tas[0]][tasR][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                        }

                     }else if(switchdir=='up'){
                        if(tasU>=0){
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tas[1]][0]][tempcubeObjmark[tas[0]][tas[1]][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tasU][tas[1]][2]], 0.06, delta)
                            easing.damp3(cubeObjarray[tempcubeObjmark[tasU][tas[1]][0]][tempcubeObjmark[tasU][tas[1]][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                        }

                     }else if(switchdir=='down'){
                        if(tasD<8){
                            easing.damp3(cubeObjarray[tempcubeObjmark[tas[0]][tas[1]][0]][tempcubeObjmark[tas[0]][tas[1]][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tasD][tas[1]][2]], 0.06, delta)
                            easing.damp3(cubeObjarray[tempcubeObjmark[tasD][tas[1]][0]][tempcubeObjmark[tasD][tas[1]][1]].position, [cubeposearray[tas[0]][tas[1]][0],cubeposearray[tas[0]][tas[1]][1],cubeposearray[tas[0]][tas[1]][2]], 0.06, delta)
                        }
                     }

                  }
                       
               
           }



           if(insertnewball){
           
                     
                console.log('creat new balls')
            

                    /**
                    *  深度拷贝对象数组（否则无法直接赋值操作） 
                    */
                  let resetcubegroup= JSON.parse(JSON.stringify(cubearray)); 

                  let marktemp=[]
                  let marksource=[]
                  let testmark=create2DArray(8, 8, 1)
                  let testmarksource=create2DArray(8, 8, 1);
                 // let randomeffector=[0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                  let randomeffector=new Array(50).fill(0);
                  randomeffector[8]=1
                 

                  for(let j=0;j<8;j++){
                    for(let i=0;i<8;i++){
                        /**
                        *  通过匹配矩阵tempPareSourcearray来关联参照数组tempcubearray以及对象数组resetcubegroup（cubearray），并进行赋值更新
                        *  
                        */
                        let sourcepoint=tempPareSourcearray[j][i] //获取指针
                        if(tempcubearray[j][i].mark==true){
                          
                       
                        
                          //清除原始矩阵(拷贝)及对象数组状态
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].mark=false  
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].effecterC=false  
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].effecterA=false  
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].effecterC_pro=false  
                          tempcubearray[j][i].mark=false
                          tempcubearray[j][i].effecterC=false
                          tempcubearray[j][i].effecterA=false
                          tempcubearray[j][i].effecterC_pro=false


                          //创建特殊消除效果A
                          //1/10概率产生特效
                          let peref=Math.floor(Math.random() * 60)-1
                           if(randomeffector[peref]==1){
                            tempcubearray[j][i].effecterA=true
                            resetcubegroup[sourcepoint[0]][sourcepoint[1]].effecterA=true  
                            if(!store.effecta)store.effecta=true
                           }


                           //创建新的数字并通过匹配矩阵赋值到原始矩阵的拷贝中，同时赋值到参照数组
                          /**
                           * 在已经创建的数组中随机取一个数字
                           */
                          let randomchoose=Math.floor(Math.random() * 5)  
                          //console.log(randomchoose+'////////////////////////')
                          let creatnum=randnum[randomchoose]
                          let balltype=genballs(false,creatnum)  
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].number=balltype.Num
                          resetcubegroup[sourcepoint[0]][sourcepoint[1]].type=JSON.parse(JSON.stringify(balltype))
  
                          tempcubearray[j][i].number=balltype.Num
                          tempcubearray[j][i].type=JSON.parse(JSON.stringify(balltype))


                          //通过指针位置更新新建Three对象，初始位置移动到最顶部
                          cubeObjarray[tempcubeObjmark[j][i][0]][tempcubeObjmark[j][i][1]].position.z=-12
 
                        }
                   
                        
                    }
        
                   }

                   /**
                    * 
                    * 创建特殊消除效果C
                    */
                   if(effecterballa!=null){
                    // if(tempcubearray[effecterballa[0]][effecterballa[1]].number!=targetnum){ //目标收集数字不享有特殊效果
                       
                          let efta=tempPareSourcearray[effecterballa[0]][effecterballa[1]]
                              resetcubegroup[efta[0]][efta[1]].effecterC=true 
                              tempcubearray[effecterballa[0]][effecterballa[1]].effecterC=true
                           
                               //如果当前对象已经是特殊效果A，则被覆盖成特效C
                             
                                resetcubegroup[efta[0]][efta[1]].effecterA=false
                                tempcubearray[effecterballa[0]][effecterballa[1]].effecterA=false
                             

                          effecterballa=null
                    // }else{
                        //effecterballa=null
                   // }
                          
                   }


                   
 
                  /* 参照组测试 */
                   for(let l=0;l<8;l++){
                    for(let m=0;m<8;m++){
                        let sp=tempPareSourcearray[l][m] //获取指针
                        testmark[l][m]=tempcubearray[l][m].number
                        testmarksource[l][m]= resetcubegroup[sp[0]][sp[1]].number  

                           //  resetcubegroup[sourcepoint[0]][sourcepoint[1]].pare=tempcubeObjmark[j][i]//在原数组中保存并更新对应的参照数组指针
                          // resetcubegroup[sp[0]][sp[1]].pare=[0,0]
                       
                        
                         
                    }
                   }
                  
                   
                  
                   console.log(testmark) 
                   console.log(testmarksource) 
                 //  console.log(tempcubearray) 

                 cubearray=JSON.parse(JSON.stringify(resetcubegroup));  //更新原始数组
                   
                 setcubegroup(resetcubegroup)

                 touchendtarget=null //释放特殊标记
                 
                 //检测新建球后是否有匹配变化
                 setTimeout(() => {
                  movingballdown=false//释放往下移动球状态
                 
                  detectAndMarkMatches(tempcubearray,false)
                  
                 }, 500);

                  
                  insertnewball=false
      
           }
         
            
         

        }

     
       
       
        
      });


   

      return (
         <group ref={ballscontainer} >

 


         {showballsitems ? (
               
              
               cubegroup.map((rowitems, rowindex) => ( 

                rowitems.map((item, index) => (

               <group
               ref={el => {
                // 确保每行的引用数组已经初始化
                if (!objectRefs.current[rowindex]) {
                  objectRefs.current[rowindex] = [];
                }
                objectRefs.current[rowindex][index] = el;
              }}
              key={`${rowindex}-${index}`} // 修改key以保证全局唯一性
              
               >
               <Cubeitem             
                cubescale={item.scale} 
                cubecolor={item.color}
                cubetype={item.type}
                block={item.block}
                pare={item.pare}
                tempmatch={item.tempmatch}
                effecterA={item.effecterA}
                effecterC={item.effecterC}
                effecterC_pro={item.effecterC_pro}
                mark={item.mark}
                
             />
 
             </group>
              ))
            ))
            ):('')}
       
         </group>
      );

}

/**
 * 移动对象并填补被消除的对象
 * move ball
 */


function moveballdown(grid){
    const rows = grid.length;
    const cols = grid[0].length;
    movingballdown=true
   // console.log('move ball')

 
    let tempgrid=JSON.parse(JSON.stringify(grid));

    let checkpointk=0  //标记循环遍历是否完成

    let tempObjarray=[...cubeObjarray]

    blankmark=[]
    
    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols ; j++) {

           
         const cleanmark = grid[i][j].mark;
          if (i>0 && cleanmark && grid[i-1][j].mark==false){
 
            checkpointk+=1
            //设置参照矩阵数组tempmatcharray 没有实际作用方便观察 
            tempmatcharray[i][j]= grid[i-1][j].number
            tempmatcharray[i-1][j]=0

            
            
            //更新匹配矩阵数组 上下互换位置 ，参考数组更新
            let balldataa=JSON.parse(JSON.stringify(tempgrid[i-1][j]));
            let balldatab=JSON.parse(JSON.stringify(tempgrid[i][j]));
            //tempgrid[i][j]=JSON.parse(JSON.stringify(tempgrid[i-1][j]));
            //tempgrid[i][j].mark=false
            //tempgrid[i-1][j].mark=true 
            tempgrid[i][j]=balldataa
            tempgrid[i-1][j]=balldatab

 
            //通过参照指针 tempcubeObjmark 记录三维对象实例的位置变化（移动循环结束后再一次性更新三维实例位置），指针地址指向实例，确保无论怎么移动位置都能找到对应的Three对象实例。
            
            let taa=tempcubeObjmark[i-1][j]
            let tab=tempcubeObjmark[i][j]
          //  cubeObjarray[taa[0]][taa[1]].position.set(cubeposearray[i][j][0],cubeposearray[i][j][1],cubeposearray[i][j][2]) //移动三维对象
          //  cubeObjarray[tab[0]][tab[1]].position.set(cubeposearray[i-1][j][0],cubeposearray[i-1][j][1],cubeposearray[i-1][j][2]) //移动三维对象
              
            tempcubeObjmark[i-1][j]=Array.from(tab)//更新指针位置
            tempcubeObjmark[i][j]=Array.from(taa) //更新指针位置


            //更新匹配矩阵数组 和操作三维对象实例同理。确保无论怎么移动位置都能指向原始数组库中对应的数据对象实例

            let t2pa=Array.from(tempPareSourcearray[i][j])
            let t2pb=Array.from(tempPareSourcearray[i-1][j])

              tempPareSourcearray[i][j]=t2pb
              tempPareSourcearray[i-1][j]=t2pa



              
            //因为参照矩阵位置更新了所以effecter特殊效果球 坐标位置相应下移
            if(effecterballa!=null){
                if(i-1==effecterballa[0] && j==effecterballa[1]){
                  effecterballa=[i,j]
                }
            }



 

           
           
            
          }

         //更新原始对象数组锚点坐标 用来反向索引参考坐标的位置
          cubearray[tempPareSourcearray[i][j][0]][tempPareSourcearray[i][j][1]].tempmatch=[i,j]   


         //永久冻结对象判断  ，只要在该标记域内的球都会被冻结
          let kt=[i,j] 
           const containsblock = controlblockarray.some(subArray => 
          subArray.length === kt.length && subArray.every((element, index) => element === kt[index])
          );
          if(containsblock){
            tempgrid[i][j].block=true
            cubearray[tempPareSourcearray[i][j][0]][tempPareSourcearray[i][j][1]].block=true
          }else{
            tempgrid[i][j].block=false
            cubearray[tempPareSourcearray[i][j][0]][tempPareSourcearray[i][j][1]].block=false
          }


        }
      }

      if(checkpointk==0){

             console.log('move ball down end')
           
             //插入新的数字对象
             
              moveballdownaction=true
            
             insertnewball=true
           
              

      }else{

     
      grid=JSON.parse(JSON.stringify(tempgrid));
      tempcubearray=grid
     // console.log(tempmatcharray)
     // console.log(tempcubearray)
     // console.log(checkpointk) 
     // moveballdownaction=true



        moveballdown(tempcubearray) //自循环直到移动所有空对象到最顶端
      }
   


}



/**
 * 检测匹配相同对象
 * check ball num and colors
 */


 function Checkball_colors(){
       if(cubearray.length<=0)return

     //  detectAndMarkMatches(cubearray)

 }

 function detectAndMarkMatches(grid,checkmod) {
   
    const rows = grid.length;
    const cols = grid[0].length;
  
    // 标记匹配的临时数组
    const toBeCleared = Array.from({ length: rows }, () => Array(cols).fill(false));
  
        // 检测水平匹配
        for (let i = 0; i < rows; i++) {
          for (let j = 0; j < cols - 2; j++) {
            const markNum = grid[i][j].number;//数值匹配
            //前置条件满足三个能够匹配===
            if (markNum && markNum === grid[i][j + 1].number && markNum === grid[i][j + 2].number) {
               //冻结匹配
              if(grid[i][j].block || grid[i][j + 1].block ||  grid[i][j + 2].block){
                //判断三个球中任意存在冻结对象
              }else{
              

                      // 检测是否有4个连续
                    if (j + 3 < cols && markNum === grid[i][j + 3].number) {
                                          
                                   //判断是否有block
                                    if(grid[i][j + 3].block){
                                        //判断是否有block

                                                 // 有block，正常标记3个连续
                                                 toBeCleared[i][j] = toBeCleared[i][j + 1] = toBeCleared[i][j + 2] = true;

                                    }else{


                                        // 五连处理逻辑
                                        if (j + 4 < cols && markNum === grid[i][j + 4].number) {

                                               /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                                     * effecterA
                                                     * **/
                                               if(grid[i][j].effecterA || grid[i][j + 1].effecterA ||  grid[i][j + 2].effecterA ||  grid[i][j + 3].effecterA ||  grid[i][j + 4].effecterA){
                                                if(effecterA_enable){
                                                      effecterA_num=markNum
                                                  }
                                                  effectbonus=true 
                                               }

                                                /**如果有特殊效果对象则进行特殊消除标记----------------------------------------
                                                 * effecterC
                                                 * **/
                                                if(grid[i][j].effecterC || grid[i][j + 1].effecterC ||  grid[i][j + 2].effecterC ||  grid[i][j + 3].effecterC ||  grid[i][j + 4].effecterC){

                                                      for(let k=j;k<=j+4;k++){
                                                        if( grid[i][k].effecterC) {
                                                          toBeCleared[0][k] = toBeCleared[1][k] = toBeCleared[2][k] = toBeCleared[3][k] = toBeCleared[4][k] = toBeCleared[5][k] = toBeCleared[6][k] = toBeCleared[7][k]= true;//列排全消
                                                        } 
                                                        }
                                                        toBeCleared[i][0] = toBeCleared[i][1] = toBeCleared[i][2] = toBeCleared[i][3] = toBeCleared[i][4] = toBeCleared[i][5] = toBeCleared[i][6] = toBeCleared[i][7]= true;//横排全消
                                                        effectotboom=true
                                                }
                                      
                                               // 标记五连所有球为清除
                                              toBeCleared[i][j] = toBeCleared[i][j + 1] = toBeCleared[i][j + 2] = toBeCleared[i][j + 3] = toBeCleared[i][j + 4] = true;
                                                // 如果有4个连续，特殊标记
                                              // 如果不是主动操作形成四连消
                                              if(touchendtarget==null){          
                                                touchendtarget=[i,j+1] //取4个第二个作为特殊标记
                                                toBeCleared[i][j + 1]=false//消除删除标记
                                              //主动操作形成四连消
                                              }else{              
                                                //使用操作的对象作为特殊标记
                                                toBeCleared[touchendtarget[0]][touchendtarget[1]]=false//消除删除标记
                                              }

                                              effecterballa=touchendtarget
                                              j += 4; // 跳过已检查的5个连续
                                        }else{

                                                    /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                                     * effecterA
                                                     * **/
                                                    if(grid[i][j].effecterA || grid[i][j + 1].effecterA ||  grid[i][j + 2].effecterA ||  grid[i][j + 3].effecterA){
                                                          if(effecterA_enable){
                                                                effecterA_num=markNum
                                                            }
                                                            effectbonus=true 
                                                      }

                                                    /**如果有特殊效果对象则进行特殊消除标记----------------------------------------
                                                     * effecterC
                                                     * **/
                                                    if(grid[i][j].effecterC || grid[i][j + 1].effecterC ||  grid[i][j + 2].effecterC ||  grid[i][j + 3].effecterC){

                                                          for(let k=j;k<=j+3;k++){
                                                            if( grid[i][k].effecterC) {
                                                              toBeCleared[0][k] = toBeCleared[1][k] = toBeCleared[2][k] = toBeCleared[3][k] = toBeCleared[4][k] = toBeCleared[5][k] = toBeCleared[6][k] = toBeCleared[7][k]= true;//列排全消
                                                            } 
                                                            }
                                                            toBeCleared[i][0] = toBeCleared[i][1] = toBeCleared[i][2] = toBeCleared[i][3] = toBeCleared[i][4] = toBeCleared[i][5] = toBeCleared[i][6] = toBeCleared[i][7]= true;//横排全消
                                                            effectotboom=true
                                                    }

                                            
                                                      // 标记4连所有球为清除
                                                    toBeCleared[i][j] = toBeCleared[i][j + 1] = toBeCleared[i][j + 2] = toBeCleared[i][j + 3] =true;
                                                      // 如果有4个连续，特殊标记
                                                    // 如果不是主动操作形成四连消
                                                    if(touchendtarget==null){          
                                                      touchendtarget=[i,j+1] //取4个第二个作为特殊标记
                                                      toBeCleared[i][j + 1]=false//消除删除标记
                                                    //主动操作形成四连消
                                                    }else{              
                                                      //使用操作的对象作为特殊标记
                                                      toBeCleared[touchendtarget[0]][touchendtarget[1]]=false//消除删除标记
                                                    }

                                                    effecterballa=touchendtarget
                                                    j += 3; // 跳过已检查的4个连续
                                          }

                                        }


                                         


                    } else {

                                  /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                 * effecterA
                                 * **/
                                  if(grid[i][j].effecterA || grid[i][j + 1].effecterA ||  grid[i][j + 2].effecterA){
                                    if(effecterA_enable){
                                       effecterA_num=markNum
                                    }
                                    effectbonus=true 
                                  }


                                /**如果有特殊效果对象则进行特殊消除标记--------------------------------------------------------
                                 * 
                                 * **/
                                if(grid[i][j].effecterC || grid[i][j + 1].effecterC ||  grid[i][j + 2].effecterC){
                                      console.log('effecter boom !!!!!!')
                                      for(let k=j;k<=j+2;k++){
                                            if( grid[i][k].effecterC ) {
                                              toBeCleared[0][k] = toBeCleared[1][k] = toBeCleared[2][k] = toBeCleared[3][k] = toBeCleared[4][k] = toBeCleared[5][k] = toBeCleared[6][k] = toBeCleared[7][k]= true;//列排全消
                                            } 
                                      }
                                            toBeCleared[i][0] = toBeCleared[i][1] = toBeCleared[i][2] = toBeCleared[i][3] = toBeCleared[i][4] = toBeCleared[i][5] = toBeCleared[i][6] = toBeCleared[i][7]= true;//横排全消
                                            effectotboom=true


                                } 


                                // 只有3个连续，正常标记
                                toBeCleared[i][j] = toBeCleared[i][j + 1] = toBeCleared[i][j + 2] = true;

                                 
                          
                    }
                
              }
    
            }
          }
        }
  
        // 检测垂直匹配
        for (let j = 0; j < cols; j++) {
          for (let i = 0; i < rows - 2; i++) {
            const markNum = grid[i][j].number;
            if (markNum && markNum === grid[i + 1][j].number && markNum === grid[i + 2][j].number) {
                  if(grid[i][j].block || grid[i + 1][j].block ||  grid[i + 2][j].block){
                    //判断三个球中任意存在冻结对象
                  }else{

                  
                          // 检测是否有4个连续
                        if (i + 3 < rows && markNum === grid[i + 3][j].number) {


                                    //判断是否有block
                                    if(grid[i+3][j].block){
                                      //判断是否有block
                                      console.log('has block item')
                                           // 有block，正常标记3个连续
                                           toBeCleared[i][j] = toBeCleared[i + 1][j] = toBeCleared[i + 2][j] = true;
                                     }else{


                                      // 五连处理逻辑

                                      if (i + 4 < rows && markNum === grid[i + 4][j].number) {
                                           /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                             * effecterA
                                             * **/
                                           if(grid[i][j].effecterA || grid[i+1][j].effecterA ||  grid[i+2][j].effecterA ||  grid[i+3][j].effecterA ||  grid[i+4][j].effecterA){
                                            if(effecterA_enable){
                                              effecterA_num=markNum
                                            }
                                            effectbonus=true 
                                          }
                                
                                          /**如果有特殊效果对象则进行特殊消除标记
                                           * 
                                           * **/
                                          if(grid[i][j].effecterC || grid[i+1][j].effecterC ||  grid[i+2][j].effecterC ||  grid[i+3][j].effecterC  ||  grid[i+4][j].effecterC){
                                            console.log('effecter boom !!!!!!')
                                            for(let k=i;k<=i+3;k++){
                                                  if( grid[k][j].effecterC ) {
                                                    toBeCleared[k][0] = toBeCleared[k][1] = toBeCleared[k][2] = toBeCleared[k][3] = toBeCleared[k][4] = toBeCleared[k][5] = toBeCleared[k][6] = toBeCleared[k][7]= true;//列排全消
                                                  } 
                                            }
                                                    toBeCleared[0][j] = toBeCleared[1][j] = toBeCleared[2][j] = toBeCleared[3][j] = toBeCleared[4][j] = toBeCleared[5][j] = toBeCleared[6][j] = toBeCleared[7][j]= true;//横排全消
                                                    effectotboom=true
              
                                          }
                                          // 五连处理逻辑
                                          toBeCleared[i][j] = toBeCleared[i + 1][j] = toBeCleared[i + 2][j] = toBeCleared[i + 3][j] = toBeCleared[i + 4][j] = true;
                                            // 如果不是主动操作形成四连消
                                            if(touchendtarget==null){          
                                              touchendtarget=[i+1,j] //取4个第二个作为特殊标记
                                              toBeCleared[i+1][j]=false//消除删除标记
                                              //主动操作形成四连消
                                            }else{
                                
                                              //使用操作的对象作为特殊标记
                                              toBeCleared[touchendtarget[0]][touchendtarget[1]]=false//消除删除标记
                                            }
                                            effecterballa=touchendtarget
                                          i += 4; // 跳过已检查的5个连续
                                      }else{

                                            /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                             * effecterA
                                             * **/
                                            if(grid[i][j].effecterA || grid[i+1][j].effecterA ||  grid[i+2][j].effecterA ||  grid[i+3][j].effecterA){
                                              if(effecterA_enable){
                                                effecterA_num=markNum
                                              }
                                              effectbonus=true 
                                            }
                                  
                                            /**如果有特殊效果对象则进行特殊消除标记
                                             * 
                                             * **/
                                            if(grid[i][j].effecterC || grid[i+1][j].effecterC ||  grid[i+2][j].effecterC ||  grid[i+3][j].effecterC){
                                              console.log('effecter boom !!!!!!')
                                              for(let k=i;k<=i+3;k++){
                                                    if( grid[k][j].effecterC ) {
                                                      toBeCleared[k][0] = toBeCleared[k][1] = toBeCleared[k][2] = toBeCleared[k][3] = toBeCleared[k][4] = toBeCleared[k][5] = toBeCleared[k][6] = toBeCleared[k][7]= true;//列排全消
                                                    } 
                                              }
                                                      toBeCleared[0][j] = toBeCleared[1][j] = toBeCleared[2][j] = toBeCleared[3][j] = toBeCleared[4][j] = toBeCleared[5][j] = toBeCleared[6][j] = toBeCleared[7][j]= true;//横排全消
                                                      effectotboom=true
                
                                            }
                                         
                                         // 标记4连所有球为清除
                                          toBeCleared[i][j] = toBeCleared[i + 1][j] = toBeCleared[i + 2][j] = toBeCleared[i + 3][j] = true;
                                           // 如果有4个连续，特殊标记
                                          // 如果不是主动操作形成四连消
                                          if(touchendtarget==null){          
                                            touchendtarget=[i+1,j] //取4个第二个作为特殊标记
                                            toBeCleared[i+1][j]=false//消除删除标记
                                            //主动操作形成四连消
                                          }else{
                              
                                            //使用操作的对象作为特殊标记
                                            toBeCleared[touchendtarget[0]][touchendtarget[1]]=false//消除删除标记
                                          }
                                          effecterballa=touchendtarget
                                         
                                          i += 3; // 跳过已检查的4个连续
                                      }

                                    }

                                       

                      } else {


                                  /**如果有特殊效果对象则进行特殊消除标记--------------------------------------
                                  * effecterA
                                  * **/
                                  if(grid[i][j].effecterA || grid[i+1][j].effecterA ||  grid[i+2][j].effecterA){
                                    if(effecterA_enable){
                                       effecterA_num=markNum
                                  }
                                  effectbonus=true 
                                 }

                                  /**如果有特殊效果对象则进行特殊消除标记
                                   * 
                                   * **/
                                  if(grid[i][j].effecterC || grid[i+1][j].effecterC ||  grid[i+2][j].effecterC){
                                        console.log('effecter boom !!!!!!')
                                        for(let k=i;k<=i+2;k++){
                                              if( grid[k][j].effecterC ) {
                                                toBeCleared[k][0] = toBeCleared[k][1] = toBeCleared[k][2] = toBeCleared[k][3] = toBeCleared[k][4] = toBeCleared[k][5] = toBeCleared[k][6] = toBeCleared[k][7]= true;//列排全消
                                              } 
                                        }
                                                toBeCleared[0][j] = toBeCleared[1][j] = toBeCleared[2][j] = toBeCleared[3][j] = toBeCleared[4][j] = toBeCleared[5][j] = toBeCleared[6][j] = toBeCleared[7][j]= true;//横排全消
                                                effectotboom=true

                                  } 
                              
                                  // 只有3个连续，正常标记
                                  toBeCleared[i][j] = toBeCleared[i + 1][j] = toBeCleared[i + 2][j] = true;

                            
                      }
                }
            }
          }
        }
    
     //正式检测
    if(checkmod==false){
            deleteProcess=true
            // 标记匹配的元素为null
            deletemark=[]
            tempmatcharray=create2DArray(8, 8, 1);
            for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                if (toBeCleared[i][j] || grid[i][j].number==effecterA_num) {
                grid[i][j].mark = true; // 或使用特定值标记以便消除
                deletemark.push([i,j])
                tempmatcharray[i][j]=0
                }
            }
            }

            //console.log(deletemark)
            
            if(deletemark.length>0){
                //tempcubearray= Array.from(grid)
                tempcubearray=JSON.parse(JSON.stringify(grid));
                
                removeballaction=true

               

                if(movingballdown==false){
                    setTimeout(() => {
                      moveballdown(tempcubearray)
                    }, 500);
                }
                
            }else{
                console.log('No match')
                deleteProcess=false //解除删除进程
            }
   //纯测试不进行删除操作
    }else{
               effecterballa=null
              // 标记匹配的元素为null
              let testdeletemark=[]
              for (let i = 0; i < rows; i++) {
              for (let j = 0; j < cols; j++) {
                  if (toBeCleared[i][j]) {
                  
                    testdeletemark.push([i,j])
                  
                  }
              }
              }

           
            if(testdeletemark.length>0){
               return true
                
            }else{
                return false
            }

    }
    
  }

 

  function Boxcontaint(props){

    const itemref = useRef()
    const meshref= useRef()
    const htmleffecter= useRef()
    const roundref= useRef()
    const { nodes, materials } = useGLTF(hostloca+'models/game2stage.glb')
    const [ divboxar, setdivboxar ] = useState([])
    const [ showeffectbox, setshoweffectbox ] = useState(false)

    const { camera, size } = useThree();
   const [divSize, setDivSize] = useState(100); // 初始假设值
   const [screenSize, setScreenSize] = useState({ width: 0, height: 0 });

  
 
     
  //  let geoshape=nodes.box.geometry
    useEffect(() => {
        /*
        // 更新摄像机
         let effectboxarray=create2DArray(8, 8, 0);
            
       
         if (htmleffecter.current && camera) {
          const vector = new THREE.Vector3();
          const plane = htmleffecter.current;
    
          // 将3D对象的边界框转换为屏幕空间坐标
          const box = new THREE.Box3().setFromObject(plane);
          const width = box.max.x - box.min.x;
          const height = box.max.y - box.min.y;
    
          // 简单的透视投影计算
          const dist = camera.position.y - plane.position.y;
          const vFov = (camera.fov * Math.PI) / 180;
          const planeHeightAtDist = 2 * Math.tan(vFov / 2) * dist;
          const planeWidthAtDist = planeHeightAtDist * camera.aspect;
    
          // 计算屏幕上的尺寸
          const planeScreenHeight = (height / planeHeightAtDist) * size.height;
          const planeScreenWidth = (width / planeWidthAtDist) * size.width;


          

          let shifleft=0
          let shiftop=0
          let cubesize=window.innerWidth/9.2
          let cubex =shifleft
          let cubey=shiftop
             
          let rows=8
          let cols=8

          cubesize=planeScreenWidth*.186
        
          shifleft=-(cubesize+1)*4
          shiftop=-(cubesize+1)*4

          for(var j=0;j<rows;j++){
            for(var i=0;i<cols;i++){
                        cubex = shifleft+i*(cubesize+1)
                        cubey=shiftop +(cubesize+1)*j
                        const boxitem={size:cubesize,scale:1,match:[j,i],show:true,position:[cubex,cubey]}    
                        effectboxarray[j][i]=boxitem
            }
         }

         setdivboxar(effectboxarray)

         setScreenSize({ width: planeScreenWidth, height: planeScreenHeight });

       

           setshoweffectbox(true)

          }*/

      }, []);





      useFrame(()=>{
         
        itemref.current.rotation.z =global_shake_rotate_z
        itemref.current.rotation.x =global_shake_rotate_z/2
      })

      return(

        <group  ref={itemref} {...props} position={[0,0,-5]} scale={[13,13,13]} dispose={null} rotation={[0,0,0]}>
      
 
      <mesh ref={roundref}   scale={[1,1,1]} rotation={[0,0,0]} position={[0,-0.1,.3]} geometry={nodes.stage6.geometry} material={materials.stage} > 
  
        </mesh>  
 
     

     
      
        </group>
      )



  }

  function Boxsother(props){

    const itemref = useRef()
    const meshref= useRef()
    const stickref= useRef()
    const roundrefa= useRef()
    const roundrefb= useRef()
    const roundrefc= useRef()
    const roundrefd= useRef()
    const { nodes, materials } = useGLTF(hostloca+'models/game2stage_others.glb')
  //  let geoshape=nodes.box.geometry
    useEffect(() => {
        // 更新摄像机
       // camera.position.z = 5;
       
      }, []);


      useFrame(()=>{
         
        itemref.current.rotation.z =global_shake_rotate_z
        itemref.current.rotation.x =global_shake_rotate_z/2

        if(Gamestart){
            if(roundrefb.current.position.y >0) roundrefb.current.position.y -=0.01
           if(roundrefb.current.position.x <4) roundrefb.current.position.x +=0.01


          
           
        }
      })

      return(

        <group  ref={itemref} {...props} position={[0,0,-5]} scale={[13,13,13]} dispose={null} rotation={[0,0,0]}>
      
      
        
       
        <mesh ref={roundrefa}   scale={[1,1,1]} rotation={[0,0,0]} position={[1,-1.6,1]} geometry={nodes.stage7.geometry} material={materials.stage} >
       
 
        </mesh>  

        <mesh ref={roundrefb}   scale={[1,1,1]} rotation={[0,0,0]} position={[1,-.5,-2]} geometry={nodes.stage7.geometry} material={materials.stage} >
         
       </mesh>

       <mesh ref={roundrefc}   scale={[1,1,1]} rotation={[0,0,0]} position={[-1,-2.3,.6]} geometry={nodes.stage7.geometry} material={materials.stage} >
       
 
       </mesh>


       <mesh ref={roundrefd}   scale={[1.6,1.6,1.6]} rotation={[0,0,0]} position={[1.7,-2,.6]} geometry={nodes.stage7.geometry} material={materials.stage} >
       
 
       </mesh>

     
    
        </group>
      )



  }


  function Overlayglass(props){

    const gref = useRef()
  
    useEffect(() => {
        // 更新摄像机
       // camera.position.z = 5;
    //   gref.current.material.color='#f0f0f0'
    overlaylook=gref.current
      }, []);


    useFrame(({ viewport, camera, pointer }, delta) => {
           let bv=true
      //  easing.damp3(gref.current.scale, bv ? 4 : 0.01, bv ? 0.5 : 0.2, delta)
       // gref.current.lookAt(camera.position)
      // console.log('cam')
      // console.log(camera.position)
      
       //console.log(camera.rotation)

       if(overlaylook!=null){
        overlaylook.lookAt(camera.position)
      }
       
    })
    return (
      <group>
        <mesh ref={gref}>
          <circleGeometry args={[10, 64,64]} />
          <meshStandardMaterial  transparent={true} opacity={0} />  

          
        </mesh>
        
      </group>
    )


  }

  function BackgroundPlane() {
    const texture = useLoader(TextureLoader, hostloca+'Assets/23.jpg');
    const planeRef = useRef();
    const { camera, size } = useThree();
    const [htmlContent, setHtmlContent] = useState( <span style={{color:'white',fontSize:'24px',backgroundColor:'pink'}}>SCORE : 520sdfasdfasdf</span>);

    let aspectRatio=9/18
  
    useEffect(() => {
      // 更新摄像机
     // camera.position.z = 5;
       setTimeout(() => {
        setHtmlContent(
            <span style={{color:'white',fontSize:'24px',backgroundColor:'pink'}}>SCORE : 520sdfasdfasdf</span>
          
          );

          console.log('add html')
       }, 1000);
   


    }, []);
  
    useFrame(() => {
      // 使平面始终朝向摄像机
      //planeRef.current.lookAt(camera.position);
      
    });
  
    // 计算平面尺寸以保持图片比例并全屏显示
    const width = camera.position.z * Math.tan((camera.fov * Math.PI) / 360) * 2;
    const height = width / size.width * size.height;
    const planeWidth = aspectRatio > width / height ? width : height * aspectRatio;
    const planeHeight = aspectRatio > width / height ? width / aspectRatio : height;
  
    return (
      <mesh ref={planeRef} position={[0, 0, -camera.position.z]}>
        <planeGeometry attach="geometry" args={[planeWidth, planeHeight]} />
        <meshBasicMaterial attach="material" map={texture}  />
          
            {htmlContent &&   <Html   position={[0, 0, -1]} rotation={[0,0,0]}   >{htmlContent}</Html>}

      </mesh>
    );
  }

  function Light() {
    const ref = useRef()
    useFrame((_) => (ref.current.rotation.x = _.clock.elapsedTime))
    return (
      <group ref={ref}>
        <rectAreaLight width={15} height={100} position={[30, 30, -10]} intensity={5} onUpdate={(self) => self.lookAt(0, 0, 0)} />
      </group>
    )
  }



  function PerformanceAdjuster() {
    const { gl, camera, scene } = useThree();
    const frameCount = useRef(0);
    const badFrames = useRef(0);

    useFrame((state, delta) => {
      if(Gamefinish){
        
      }
        else{
              frameCount.current++;
              if (delta > 1 / 30) { // 小于30 FPS时
                  badFrames.current++;
              }

              if (frameCount.current > 120) { // 每120帧评估一次
                  const badFrameRatio = badFrames.current / frameCount.current;
                  if (badFrameRatio > 0.1) { // 如果超过10%的帧率不达标
                      const newDpr = Math.max(0.8, gl.getPixelRatio() - 0.25); // 逐步降低 DPR
                      console.log('change dpr :'+newDpr)
                      gl.setPixelRatio(newDpr);
                  } else {
                      const newDpr = Math.min(1.5, gl.getPixelRatio() + 0.25); // 逐步提高 DPR
                      console.log('change dpr :'+newDpr)
                      gl.setPixelRatio(newDpr);
                  }
                  // 重置帧计数器和坏帧计数器
                  frameCount.current = 0;
                  badFrames.current = 0;
              }
        }
    });

    return null; // 不渲染任何实际内容
}



/**
 * Three js scene
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
 

function Scene(props) {
 
    const [loadfinish, setloadfinish] = useState(0);
 
    
    const blackboardRef=useRef(null)
    const glElement=useRef(null)
    const glcontainer=useRef(null)
    const [coveralpha, setcoveralpha] = useState(1);
    const [glcontaineralpha, setglcontaineralpha] = useState(1);
    const Loadmanager = new THREE.LoadingManager();
    const textureLoader = new THREE.TextureLoader(Loadmanager);
    const [startalpha, setstartalpha] = useState(1);
    
     const [dpr,setdpr]=useState(1)
 
     const store = useStore()

    const pointLightRef =useRef();

    const [isPaused,setisPaused]=useState('always')
    

  
    const isMobile=false
   
    THREE.ColorManagement.legacyMode = false

    var kks=0
    var subtitleY=40

    const [loaderw, setloaderw] = useState(0);
    const [loaderprogress, setloaderprogress] = useState(0);
    const [loaderalpha, setloaderalpha] = useState(1);
    const [seconds, setSeconds] = useState(0);
    let loadingtips=['有圆圈的数字代表本关需要收集的目标','有花纹的数字可触发十字消除','四个相同数字消除可获得十字消除','有菱形反光的数字可消除所有相同的数字']
    const [tipstxt, settipstxt] = useState(loadingtips[Math.floor(Math.random()*loadingtips.length)]);
    const [tipstxtalpha, settipstxtalpha] = useState(0);
    const timerset=useRef()

    useEffect(() => {
         // 创建定时器
         const interval = setInterval(() => {
         setSeconds(seconds => seconds + 1); // 注意这里使用函数式更新
         }, 200);
         timerset.current=interval
         // 清除定时器的逻辑
         return () => clearInterval(interval);
    }, []); // 空依赖数组表示这个 effect 只在挂载时运行一次
    
    useEffect(() => {
     //console.log(seconds) 
     
      if(loaderw< 100){

       

        //缓冲一般loading动画
        if(loaderw<50){
          setloaderw(loaderw => loaderw + 5)
          if(seconds>5 ){
            if(tipstxtalpha==0)settipstxtalpha(1)
          }
        }else{
           //检查是否比实际loading快
           if(loaderw>loaderprogress){
                console.log('wait for loading'+loaderprogress)
                if(seconds>50){ //总共加载10秒后强制取消loading
                console.log('loading progress time out'+loaderprogress)
                settipstxtalpha(0)
                setloaderw(100)
                Endloader()
                clearInterval(timerset.current);
                }
               
                
           }else{
                setloaderw(loaderw => loaderw + 5)
           }
        }
     
      }else{
              if(loaderalpha!=0){
                Endloader()
              }
              console.log('clear interval')
              clearInterval(timerset.current);
      }
   
    }, [seconds]);  
    

    function loadderdone(progress){

     // console.log('loaded=========='+progress)
  
      if(progress!=0 &&  loaderprogress<progress){
        let addprogress=loaderprogress+(progress-loaderprogress)
        setloaderprogress(addprogress)
        //  console.log('myloaded=========='+loaderprogress)
      } 
      if(progress>=100){
        if(seconds>15){//强制加载3秒
          Endloader()
        }
      }
     
    }
 
    useEffect(() => {
        if(coveralpha==0){
            setTimeout(() => {
              setstartalpha(0)
            }, 2000);
      
        }
     
    },[coveralpha]); 



    function Endloader(){
          settipstxtalpha(0)
          setloaderalpha(0)
          setTimeout(() => {
                if(store.loaded)return
                setcoveralpha(0)
                store.loaded=true
                console.log('loader done-------------'+ store.loaded)
            }, 1000);
         
    }
   
   useEffect(()=>{
    

    if(isAndroid){

       // setdpr(.8)
        Android=true
      
    }

    //console.log('scene loadfinish')
   },[])

 

    return(<div ref={glcontainer} style={{width:'100vw',height:'100vh',opacity:glcontaineralpha,position:'absolute',left:0}} >

           <Canvas   id={'threecanvas'}     camera={{ position: [48, 33, 67],rotation:[-.47,-5.7825,0],fov:50}}    dpr={[.6, dpr]}  gl={{ antialias: true,alpha:true ,localClippingEnabled: false,preserveDrawingBuffer:false}} linear   frameloop={isPaused}  style={{width:'100vw',height:'100vh',position:'fixed'}}>
        4
           <PerformanceAdjuster />
           <Suspense fallback={<NewLoader callback={loadderdone} />}>
          
          <Cubeplanel />

           
        
          {testmode? (
           <>
      
        
            </>
            ):('')}
          
           {/*
            <Stats />
                 <Overlayglass />
            <Coordinate />
         
     camera={{ position: [0, 49, 0],rotation:[-1.57,-6.2825,0],fov:50}} 
          camera={{ position: [16, 43, 60],rotation:[-.67,-6.0825,0],fov:50}}  
           <Environment  resolution={64} files={hostloca+"data/brown_photostudio_01_1k.hdr"}  />
         
             
                <hemisphereLight intensity={0.2} />
          <ambientLight intensity={0.5} />
           <BackgroundPlane />
         
           */}
  <fog attach="fog" args={['#dddddd', 90, 110]} /> 
<Boxcontaint />
<Boxsother />
<hemisphereLight intensity={.5} />
<ambientLight intensity={.7} />

 
  <Environment  resolution={32} files={hostloca+"data/brown_photostudio_01_1k.hdr"} ></Environment>
       {/*
<Environment preset="city" background blur={1} />

        <Environment resolution={32}>
        <group rotation={[Math.PI / 2, -0.3, 0]}>
          <Lightformer intensity={20} rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={[10, 10, 1]} />
          <Lightformer intensity={2} rotation-y={Math.PI / 2} position={[-5, 1, -1]} scale={[10, 2, 1]} />
          <Lightformer intensity={2} rotation-y={Math.PI / 2} position={[-5, -1, -1]} scale={[10, 2, 1]} />
          <Lightformer intensity={2} rotation-y={-Math.PI / 2} position={[10, 1, 0]} scale={[20, 2, 1]} />
          <Lightformer intensity={2} rotation-x={-Math.PI / 2} position={[0, 4, 0]} scale={[12, 12, 11]} />

          <Lightformer type="ring" intensity={4} rotation-y={Math.PI / 2} position={[-0.1, 3, -5]} scale={10} />
        </group>
      </Environment>
        
         <CameraControls truckSpeed={0} dollySpeed={0} minPolarAngle={0} maxPolarAngle={Math.PI }  />

          <OrbitControls  
         enabled={false}
         minPolarAngle={0} // 默认值，不需要显式设置
         maxPolarAngle={Math.PI} // 默认值，不需要显式设置
         minAzimuthAngle={-Infinity} // 移除水平旋转限制
         maxAzimuthAngle={Infinity} // 移除水平旋转限制
         />

        */}
        
</Suspense>

           </Canvas>
 

           <div style={{width:'100vw',height:'100vh',verticalAlign:"center",display:'flex',alignItems:"center",position:'absolute',opacity:startalpha,transition:`all 1s ease 1s`,pointerEvents:'none',justifyContent:'center'}}>
                  <span className='textendsc' style={{fontSize:'6vw',letterSpacing:'.1vw',paddingTop:'0',paddingLeft:'1.5vw',position:'absolute',color:'white',top:'40vh'}}>Ready!</span>  
            </div> 
          
  
            <div style={{backgroundColor:"#CACACA",width:'100vw',height:'100vh',verticalAlign:"center",display:'flex',alignItems:"center",position:'absolute',opacity:coveralpha,transition:`all 1s`,pointerEvents:'none',justifyContent:'center'}}>
                     {/* <div style={{color:"#fff",fontSize:"10px",width:'100vw',textAlign:'center',pointerEvents:'none',}}>
                    <img  src={hostloca+'Assets/loading.gif'} style={{width:'20vw'}}/> 
                    </div>*/}


                    <div className='progress-bar'  style={{width:'30vw',height:'4px',position:'absolute',opacity:loaderalpha,transition:`all 1s`,marginTop:'-10vh'}}>
                          <div className='progress' style={{width:loaderw+'%',height:'4px'}}></div>
                    </div>


                    <div className='textnormal' style={{color:"#fff",fontSize:"12px",width:'100vw',textAlign:'center',pointerEvents:'none',opacity:tipstxtalpha,transition:`all .4s`}}>
                    {tipstxt}
                    </div> 

           </div> 
   
    </div>
    )
}



export default function Game2(props) {
    const store = useStore()
    const videoEl = useRef(null);
    store.step =totalstep
    store.num =targetnum
    store.collect =collect

    const [videopose,setvideopose]=useState(['100vw','100vh',0,0])
  
    function checkball(){

       // console.log(cubearray)

       detectAndMarkMatches(tempcubearray,false)
    }

    function endgame(){
      
  
       Gamefinish=true

       /*
       for(let i=0;i<3;i++){
        const sound1 = new Howl({
            src: [hostloca+'media/sound2.mp3']
          });
      
      
          sound1.play();
    }*/

      
    }

    function callback(){
      console.log('game replay')

         if(restartgame==false){
          restartgame=true
         }
    }


    function cleanball(){


        moveballdown(tempcubearray)

    }


    function insertball(){
        insertnewball=true

    }

    const attemptPlay = () => {
      videoEl &&
        videoEl.current &&
        videoEl.current.play().catch(error => {
          console.error("Error attempting to play", error);
        });
    };


    useEffect(()=>{


      let videoradio=664/320
      let h=window.innerHeight
      let videow=window.innerWidth
      let videoh=window.innerWidth*videoradio
      let videotop=0
      let videoleft=0

      if(videoh>h){

        videotop=(h-videoh)/2

      }else{
        videoh=h
        videotop=0

        videow=videoh*320/664

        videoleft=(window.innerWidth-videow)/2

      }
 
      setvideopose([videow,videoh,videoleft,videotop])
 
    attemptPlay();

 
        },[])
        



return(
   <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0}}>
      <img src={hostloca+'Assets/cbg2.jpg'} style={{height:'100%',position:'absolute',width:'100%'}}/>

     {/*
      <video
          style={{position:"absolute",display: 'block',width:videopose[0],height:videopose[1],left:videopose[2],top:videopose[3],opacity:1}}
          playsInline
          loop
          muted
          
          alt="All the devices"
          src={hostloca+'media/i1.mp4'}
          ref={videoEl}
        />

*/}



    <Scene />
   
    
{/*
   <div  onClick={()=>checkball()} style={{width:'36vw',height:'10vw',borderRadius:'8vw',backgroundColor:'white',color:'black',position:'absolute',left:'10%',top:'90vh',display:'flex',justifyContent:'center',alignItems:'center'}}>CHECK</div>

   <div  onClick={()=>endgame()} style={{width:'36vw',height:'10vw',borderRadius:'8vw',backgroundColor:'white',color:'black',position:'absolute',left:'60%',top:'84vh',display:'flex',justifyContent:'center',alignItems:'center'}}>INSERT</div>


   <div  onClick={()=>cleanball()} style={{width:'36vw',height:'10vw',borderRadius:'8vw',backgroundColor:'white',color:'black',position:'absolute',left:'60%',top:'90vh',display:'flex',justifyContent:'center',alignItems:'center'}}>MOVE</div>
*/}



   
    
   <Uilayer  callback={callback} /> 
   </div>

)

}






/**
 * dispose obj
 */



function disposeObject(obj) {
   
    if (!obj) return;
   
    // 递归释放所有子对象的资源
    obj.children.forEach(child => disposeObject(child));
  
    // 释放几何体资源
    if (obj.geometry) {
      obj.geometry.dispose();
    }
  
    // 释放材质资源
    if (obj.material) {
      if (Array.isArray(obj.material)) {
        obj.material.forEach(material => disposeMaterial(material));
      } else {
        disposeMaterial(obj.material);
      }
    }
  
    // 如果有父对象，从父对象中移除
    if (obj.parent) {
      obj.parent.remove(obj);
    }
  
    // 清除obj上的事件监听器等
    // 这步骤根据实际情况决定是否需要
  //  console.log('remove obj')
  }
  
  function disposeMaterial(material) {
    // 释放材质相关资源
    if (material.map) material.map.dispose();
    if (material.lightMap) material.lightMap.dispose();
    if (material.bumpMap) material.bumpMap.dispose();
    if (material.normalMap) material.normalMap.dispose();
    if (material.specularMap) material.specularMap.dispose();
    if (material.envMap) material.envMap.dispose();
    // 释放ShaderMaterial或RawShaderMaterial可能使用的属性
    if (material.dispose) material.dispose();
  }


  function NewLoader(props) {
    const { active, progress, errors, item, loaded, total } = useProgress()
   

    useEffect(()=>{
   

      props.callback(progress)
    
    },[progress])
   
       
    return <Html center style={{left:'-3vw'}}>
    <div style={{backgroundColor:"#CACACA",width:'100vw',height:'100vh',verticalAlign:"center",display:'flex',alignItems:"center",justifyContent:'center'}}>

      <div className='progress-bar'  style={{width:'30vw',height:'2px',position:'absolute',marginTop:'-10vh'}}>
        
           <div className='progress' style={{width:'1%'}}></div>
      </div>

    {/*
    <div style={{color:"#fff",fontSize:"10px",width:'100vw',textAlign:'center'}}>
    
         <img  src={hostloca+'Assets/loading.gif'} style={{width:'20vw'}}/> 
    </div>
   */}
    </div>
    </Html>

  }